/* this is the root-js file which should import needed files/packages */

/* alpinejs (https://github.com/alpinejs/alpine) */
import Alpine from 'alpinejs';
// import Alpine from '@alpinejs/csp'; FIXME: CSP-Version of Alpine currently not working

// ALpine Plugins
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import fern from '@ryangjchandler/fern';
import tooltip from '@ryangjchandler/alpine-tooltip';
import clipboard from '@ryangjchandler/alpine-clipboard';

// livewire hot reload
import { livewire_hot_reload as livewireHotReload } from 'virtual:livewire-hot-reload';

// livewire-toaster
import * as toaster from '../../vendor/masmerise/livewire-toaster/resources/js/toaster';
import { Hub } from '../../vendor/masmerise/livewire-toaster/resources/js/hub';

// load the iodine form-validation adapter
import initializeIodine from './iodine-form-validation';

// import 'humanFileSize';
import humanFileSize from './human-filesize';

// import `livewireEmit()`
import setLivewireEmitClickListener from './livewire-events-emitter';

// import `datepicker()`
import datePicker from './datepicker';

// import `isTouchDevice()`-helper
import isTouchDevice from './touchscreen-detection';

// import `disableScrollOnNumberInput()`-fix
import disableScrollOnNumberInput from './disable-scroll-on-number-input';

// import `countUpNumber()`-animation function
import countUpNumber from './count-up-number-animation';

// for debugging only
// import { ray } from 'node-ray/web';

// make some functions global accessable (for alpine)
window.humanFileSize = humanFileSize;
window.isTouchDevice = isTouchDevice;
window.countUpNumber = countUpNumber;
window.Toaster = toaster;

/* disabled the scroll on number input (to increase the number) (maybe happens only in chrome) */
disableScrollOnNumberInput();

/* starts the iodine frontend validation */
initializeIodine();

/* set Livewire Emit Click Listener */
setLivewireEmitClickListener();

// activate the alpine Plugins
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(fern);
Alpine.plugin(clipboard);
Alpine.plugin(tooltip);
Alpine.plugin(Hub);

// Add the Alpine data (x-data)
Alpine.data('datePicker', datePicker);

// Add the global Apline store
// TODO: check if it runs without fern Alpine.store('windowWidth', 0);
Alpine.persistedStore('windowWidth', 0);

// Start Alpine
window.Alpine = Alpine;
window.Alpine.start();

// Start the livewire hot reload (vite dev mode)
livewireHotReload();

// import images to transform;
import.meta.glob(['../img/**/*.{png,jpg,jpeg}', '../svg/**/*.{svg}', '../fonts/**']);
